import React from "react";
import "./LoadingDots.scss";

function LoadingDots() {
	return (
		<div className="loading-dots">
			<span>.</span>
			<span>.</span>
			<span>.</span>
		</div>
	);
}

export default LoadingDots;
